import { Component, OnInit } from '@angular/core';
import { AuthViewModel } from '../auth.view-model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-bad-subscription',
  templateUrl: './bad-subscription.component.html',
  styleUrls: ['./bad-subscription.component.scss'],
})
export class BadSubscriptionComponent {
  contactUsUrl = environment.externalLinks.contactUs;
  constructor(private authViewModel: AuthViewModel) {}
}
